import { render, staticRenderFns } from "./FormConsentGrid.vue?vue&type=template&id=cb3188b4&scoped=true&"
import script from "./FormConsentGrid.vue?vue&type=script&lang=js&"
export * from "./FormConsentGrid.vue?vue&type=script&lang=js&"
import style0 from "./FormConsentGrid.vue?vue&type=style&index=0&id=cb3188b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3188b4",
  null
  
)

export default component.exports